var id = 0;
var RpcProxy = /** @class */ (function () {
    function RpcProxy(_a) {
        var path = _a.path, method = _a.method;
        this.path = path;
        this.method = method;
    }
    RpcProxy.getId = function () {
        return ++id + ":" + Math.random()
            .toString(16)
            .slice(2);
    };
    RpcProxy.prototype.load = function (payload) {
        var _a = this, path = _a.path, method = _a.method, request = _a.request;
        if (!request) {
            throw new Error('RpcProxy error: before load must bee setted context via setContext');
        }
        var data = {
            jsonrpc: '2.0',
            id: RpcProxy.getId(),
            method: method,
            params: payload || {}
        };
        return request.execute('POST', "/" + path, data);
    };
    RpcProxy.prototype.setContext = function (request) {
        this.request = request;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    RpcProxy.prototype.setParams = function (params) {
        // no-op
    };
    return RpcProxy;
}());
export { RpcProxy };
//# sourceMappingURL=RpcProxy.js.map